import {Component,Inject,Input} from 'ng-metadata/core';

import { OpacService } from './opac.service';
//your imports go here
import {LimitedHistoryStack} from '../../../../infra/dataStructures/collections/stack/limitedHistoryStack.structure';
import {FullViewService} from '../../fullView.service';
import {RequestServicesService} from './request/requestsService.service';
import {LocationsService} from './locations/locations.service';


import {getInstitutionCode, getVid} from '../../../../appConfig/appConfigForward';
import {ConfigurationUtil} from '../../../../nddUtils/configurationUtil.service';
import {PrimoResponse} from '../../../../infra/dataStructures/PrimoResponses/doc.interfcae';
import {SmoothScrollUtil} from "../../../../nddUtils/smoothScrollUtil.service";
import {MappingTablesCache} from "../../../../mappingTablesCache/mappingTablesCache.service";
import { LocationsFilterService } from './locationsFilter/locationsFilter.service';

const _get = require('lodash/get');
const isEqual= require('lodash/isEqual');


@Component({
    'selector': 'prm-opac',
    templateUrl: 'components/search/fullView/getit/opac/opac.html',
})



export class PrmOpac{
    @Input() public item: PrimoResponse.IDoc;
	@Input() public serviceMode:string;
	@Input() public serviceScrollId:string;
    @Input() public memberInst:string;
    @Input() public registerUser:string;
    @Input() public isOverlayFullView:boolean;

    public loc:{location:{holKey:string;}};
    public backToHistoryStack: LimitedHistoryStack<OPAC_TAB>;
    public filters;
    public dropDownOptions;
    private defaultTab = OPAC_TAB.LOCATIONS;
    private _selectedTab:OPAC_TAB;
    private BACK_HISTORY_SIZE :number = 12;

    private _isLocationFiltered:boolean = false;
    private _isLocationsFilterVisible:boolean = false;
    private _itemId:string;
    private _mmsId:string;
    private service;
    private _locationServices;

    private headerLabelLibraries:string = "nui.locations.headerLibraries";
    private headerLabelLocations:string = "nui.locations.header";
    private GROUP_LOCATIONS_UNDER_LIBRARY_STRING: string = 'Group The Locations Under Get It By The Library Name';
    private _isShowLiraryLevelList: boolean = false;

    constructor(private opacService : OpacService,
                private configurationUtil: ConfigurationUtil,
                private fullViewService: FullViewService,
                private requestServicesService: RequestServicesService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService,
                @Inject('$scope') private $scope: ng.IScope,
                private locationsService: LocationsService,
                private locationsFilterService: LocationsFilterService,
                private smoothScrollUtil: SmoothScrollUtil,
                private mtCache: MappingTablesCache) {
        this.backToHistoryStack = new LimitedHistoryStack<OPAC_TAB>(this.BACK_HISTORY_SIZE);
        this._selectedTab = this.defaultTab;
        this.serviceScrollId = '';
        this.isOverlayFullView = false;
        this.$scope.$watch(()=>this.memberInst, (newVal,oldVal)=>{
            if (!isEqual(newVal,oldVal)) {
                this.selectedTab=this.defaultTab;
                this.backToHistoryStack = new LimitedHistoryStack<OPAC_TAB>(this.BACK_HISTORY_SIZE);
            }
        });

        let libraryLevelListEnabled = this.mtCache.findByProperties(this.mtCache.tables.LIBRARY_LEVEL_LIST, 
            {target:'Y', source1: this.GROUP_LOCATIONS_UNDER_LIBRARY_STRING}).length === 1; 
        if (this.isSuprima() && libraryLevelListEnabled && this.isMoreThanOneLibrary) {
            this._isShowLiraryLevelList = true;
            this.selectedTab = OPAC_TAB.LIBRARIES;
        }
    }

    get isCalculateSvcIdDone(){
        return this.fullViewService.isCalculateSvcIdDone();
    }

    get isServicesListIsLoadingDone(){
         return !this.isSuprima() || this.opacService.isServicesListIsLoadingDone();
    }

    get selectedTab() {
        return this._selectedTab;
    }

    set selectedTab(selectedTab) {
        this._selectedTab = selectedTab;
    }

    get responseStatus() {
        return this.opacService.responseStatus;
    }

    get isLocationFiltered() {
        return this._isLocationFiltered;
    }

    get isLocationsFilterVisible() {
        return this._isLocationsFilterVisible;
    }

    get itemId() {
        return this._itemId;
    }

    get mmsId() {
        return this._mmsId;
    }

    get locationServices() {
        return this._locationServices;
    }

    get isShowLiraryLevelList(): boolean {
       return this._isShowLiraryLevelList;
    }

    set isShowLiraryLevelList(value: boolean) {
        this._isShowLiraryLevelList = value;
    }

    get isMoreThanOneLibrary(): boolean{
        return this.locationsFilterService.getLocationDropDownOptions(this.item).length > 1 ;  
    }

    /* public functions */
    public onChangeTabEvent($event) {
        if ($event !== null && angular.isDefined($event.isFiltered)) {
             this._isLocationFiltered = $event.isFiltered;
        }

        if ($event !== null && angular.isDefined($event.itemId)) {
             this._itemId = $event.itemId;
        }else{
            this._itemId = "";
        }

        if ($event !== null && angular.isDefined($event.mmsId)) {
             this._mmsId = $event.mmsId;
        }else{
            this._mmsId = "";
        }

        if ($event !== null && angular.isDefined($event.filters)) {
             this.filters = $event.filters;
        }

        if ($event !== null && angular.isDefined($event.dropDownOptions)) {
             this.dropDownOptions = $event.dropDownOptions;
        }

        if ($event !== null && angular.isDefined($event.locationsFilterVisible)) {
             this._isLocationsFilterVisible = $event.locationsFilterVisible;
        }

		if (!this.isLocationFiltered) {
            this.filters = {};
        }        
        
        let eventData:ChangeTabEvent = $event;

        if($event === null){
            this.selectedTab = this.backToHistoryStack.pop() || this.defaultTab;
        } else {
            if(eventData.referer !== undefined && this.backToHistoryStack.peek() !== eventData.referer) {
                this.backToHistoryStack.push(eventData.referer);
            }
            if(eventData.loc !== undefined) {
                this.loc = eventData.loc;
                if(this.configurationUtil.getBackendSystem() === 'suprima'){
                    this._locationServices = this.loc.services;
                }
            }else{
                if(this.configurationUtil.getBackendSystem() === 'suprima' && eventData.dest === OPAC_TAB.LOCATIONS){
                    this._locationServices = undefined;
                    if (_get(this, 'loc.locationNoItems')){
                        this.loc.locationNoItems=false;
                    }
                }
            }

            if (eventData.service) {
                this.service = eventData.service;
            }
            if(eventData.clearStack){
                this.backToHistoryStack.clear();
            }
            if(this.configurationUtil.getBackendSystem() === 'suprima' && eventData.dest === OPAC_TAB.LIBRARIES){
                this.$scope.$broadcast("clearFiltersEvent");
                this.backToHistoryStack.clear();
            }
            if (eventData.updateLocationItems){
                if (!_get(this, 'loc.locationNoItems')){ //if there are no items on the current location no need to update the items
                    this.locationsService.getLocationsItems([[this.loc]], false,true, {}, _get(this.item, 'delivery.hideResourceSharing', false), _get(this.item, 'delivery.almaInstitutionsList[0].envURL', '')).then((res)=>{
                        this.loc = res.data.itemInfo.results[0][0];
                    });
                }
            }
            this.selectedTab = eventData.dest;
            if (!eventData.cancelFocus) {
                this.$timeout(() => {
                    if (this.isOverlayFullView) {
                        this.smoothScrollUtil.scrollTo(this.serviceScrollId, '', 'sticky-scroll');
                    }
                    else {
                        this.smoothScrollUtil.scrollTo(this.serviceScrollId, '', '');
                    }
                }, 100)
            }
        }
    }

    public onLocationFilterEvent($event){
        setTimeout(()=>{
            this.selectedTab = OPAC_TAB.LOCATIONS;
            this.backToHistoryStack.push(OPAC_TAB.LIBRARIES);  
        }, 100);
        this.$scope.$broadcast("locationFilterEvent", $event.locationFilter);
    }

    public onLibraryFilterEvent($event){
        
        setTimeout(()=>{
            this.selectedTab = OPAC_TAB.LOCATIONS;
            this.backToHistoryStack.push(OPAC_TAB.LIBRARIES);  
        }, 400);
        
        this.$scope.$broadcast("libraryFilterEvent", $event);
    }

	public hasGetit1(){
		let getitArray = _get(this.item, 'delivery.GetIt1.links', _get(this.item, 'delivery.GetIt1',[]));
		return getitArray.length > 0;
	}

    public goBack(){
        let destTab = this.backToHistoryStack.pop();
        this.selectedTab = destTab;
    }

    public availTabs(){
        return OPAC_TAB;
    }

    public hasLocations(){
         if(this.item && this.item.delivery.holding.length > 0){
            return true;
         }else{
             return false;
         }
    }

    public isSingleLoc(items) {
        let onlyViewInst = this.configurationUtil.getLocationsConfiguration().viewinstsort;
        if(!items){
            return false;
        }
        let globalitemsList = items.delivery.holding;
        globalitemsList = globalitemsList.filter((loc)=>{return (!onlyViewInst || loc.organization === getInstitutionCode());});

        return globalitemsList.length<2;
    }

    public displayBackToLocationButton() {
        return this.configurationUtil.getLocationsConfiguration()['displayholdingsfilters'] ||
        !this.isSingleLoc(this.item);
        
    }
    
    private focusOnLocations(){
        let locationsElement= document.querySelector('prm-location > button') as HTMLElement;
        this.$timeout(()=>{
            if (locationsElement){
                locationsElement.focus();
            }
        }, 100)
    }

    public getResponseMessage(){
        return this.opacService.getResponseMessage();
    }

    public getAdjustedTimesAlertPlaceHolder(){
        let responseStatus = this.opacService.responseStatus;
        return {
            start_time: responseStatus.adjustedStartTime,
            end_time: responseStatus.adjustedEndTime
        };
    }

    public isSuprima(){
      return this.configurationUtil.getBackendSystem() === 'suprima';
    }
}

export interface ChangeTabEvent{
    dest:OPAC_TAB;
    referer?:OPAC_TAB;
    loc?:{location: {holKey: string;}};
    service?:Object;
    clearStack?:boolean;
    updateLocationItems?:boolean;
    cancelFocus?: boolean;
}

export interface LocationFilterEvent{
    locationFilter:string;
}

export enum OPAC_TAB{
    LOCATIONS = 0,
    ITEMS = 1,
    REQUEST = 2,
    RESPONSE = 3,
    APPROVAL = 4,
    LIBRARIES = 5
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/opac.directive.ts